import React from 'react';
import BaseApi from '../../api/BaseApi.js';
import ScreenCaption from '../screen-caption.js';
import details from '../../img/details.svg';
import add from '../../img/add.svg';


export default class RegionsScreen extends React.Component {
    constructor(props) {
        super(props);

        const args = props.args === undefined ? {} : props.args

        this.state = {
              args: args, 
              nameCriteria: "",
              prevNameCriteria:"",
              regions: []  
        }

        this.nameCriteriaChangeHandler = this.nameCriteriaChangeHandler.bind(this); 
        this.nameSearch = this.nameSearch.bind(this);   
        setTimeout(this.nameSearch, 2000);

    }  

    getDataWithCriteria() {
        var parameters = {}
        if (this.state.nameCriteria.length > 0) {
            parameters.name = this.state.nameCriteria
        }

        BaseApi.get('/regions', {headers: {
            'Content-Type': 'application/json', 'SESSIONID' : sessionStorage.getItem("session")}, params: parameters, withCredentials: true})
        .then(res => {
            this.setState({regions: res.data})
        })    
        .catch(error=>console.log(error))

    }    
    
    async componentDidMount() {
        this.getDataWithCriteria()
    }



    nameSearch() {
        if (this.state.nameCriteria !== this.state.prevNameCriteria) {
            var args = this.state.args
            args.pageCount = 0
            this.setState({prevNameCriteria: this.state.nameCriteria, pageCount: 0, args: args}, this.getDataWithCriteria)
        }    
        setTimeout(this.nameSearch, 2000)
    }

    nameCriteriaChangeHandler(event) {
        this.setState({nameCriteria: event.target.value})
    }


    openRegion(id) {
        this.props.navigate("region", {caller: "regions", callargs: this.state.args, region: id})
    }

    renderRegion(region) {
        return (
            <tr 
                id = {region.id}
                className="table-row-clickable"
                onClick={()=>this.openRegion(region.id)}
            >
                <td style={{textAlign: 'left',  padding: '4px'}}>{region.name}</td>
                   
            </tr>
        )      
    }

    render() {
        return (
            <div class="container">
                <ScreenCaption goback={this.props.goback} args={this.state.args} caption={"Регионы"}/>

                <div className="row mt-4 mb-3">
                    <div className="col-lg-6">
                        <div className="card shadow-sm">
                            <div className="card-body">
                                <h6 className="card-title mb-3">Фильтр</h6>
                                <div className="mb-3">
                                    <label for="name">Наименование:</label>
                                    <input type="text" class="form-control" id="name" value={this.state.nameCriteria} onChange={this.nameCriteriaChangeHandler} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 d-flex flex-column align-items-end mt-3 mt-lg-0">
                        <div className="mb-2">
                            <button className="btn btn-primary d-flex align-items-center" onClick={()=>{this.openRegion("")}}>
                                Добавить регион
                            </button>
                        </div>
                    </div>
                </div>

                <div className="card shadow-sm">
                    <div className="card-body p-0">
                        <div className="table-responsive">
                            <table className="table table-sm table-hover mb-0 align-middle">
                                <thead className="table-primary">
                                    <tr>
                                        <th>
                                            Наименование
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.regions.map((value, index) => this.renderRegion(value))}
                                </tbody>

                            </table>
                        </div>
                    </div>
                </div>

                {/*
                <div class="row mt-5" style={{"height" : "50px"}}>
                        <div class="col-6 offset-2 text-left border border-white"
                            style={{"background-color" : "#0ee"}}>Наименование</div>
                        <div class="col-2 border border-white"
                            style={{"background-color" : "#0ee"}}
                            onClick={()=>{this.openRegion("")}}><img src={add} height="16" width="16"/>
                        </div>     
                    </div>    
            
                {this.state.regions.map((value, index) => this.renderRegion(value))}
                */}
        </div> 
        )
    }
}    


// WEBPACK FOOTER //
// ./src/ui/workspace-screens/regions.js